import { render, staticRenderFns } from "./DetalleRetencion.vue?vue&type=template&id=57d91d8c&scoped=true&lang=pug&"
import script from "./DetalleRetencion.vue?vue&type=script&lang=js&"
export * from "./DetalleRetencion.vue?vue&type=script&lang=js&"
import style0 from "./DetalleRetencion.vue?vue&type=style&index=0&id=57d91d8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d91d8c",
  null
  
)

export default component.exports